module.exports = __webpack_public_path__ + "img/69.c712b917.jpg";